// $FlowIgnore
import { createBrowserHistory } from "history";

const history: Object = createBrowserHistory();

export default history;
